import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MonedaSelect } from 'sharedComponents/select'

const MonedaLimiteCreditoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MONEDA LIMITE CREDITO' htmlFor='select-monedaLimiteCredito' md={3} />
      <Col md={9}>
        <Field name='monedaLimiteCredito'>
          {({ field }) => (
            <MonedaSelect
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-monedaLimiteCredito'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaLimiteCreditoFormGroup)
